import { promisifyDispatch } from 'affiny-core/modules/helpers';
import { matchesActions } from 'affiny-core/modules/matches/actions';
import { postMemberChoicesAction } from 'affiny-core/modules/memberchoices/actions';
import { IRootState } from 'affiny-core/modules/state';
import {
  searchCriteriaQuestionsLabel,
  selectMemberChoiceAnswersBySearchCriteria,
} from 'affiny-core/redux/selectors/memberChoicesSelectors';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

export interface IUpdateQuestionAnswer {
  (label: string, value: number[] | { min: number; max: number }): void;
}

export const useEditCriteria = () => {
  const dispatch = useDispatch();

  const searchCriteriaAnswers = useSelector((state: IRootState) =>
    selectMemberChoiceAnswersBySearchCriteria(
      state,
      searchCriteriaQuestionsLabel
    )
  );

  const [answers, setAnswers] = useState(searchCriteriaAnswers);

  const updateQuestionAnswer: IUpdateQuestionAnswer = (label, value) => {
    setAnswers(prevAnswers => ({
      ...prevAnswers,
      [label]: value,
    }));
  };

  const saveSearchCriteria = () => {
    promisifyDispatch(
      dispatch,
      postMemberChoicesAction
    )(answers).then(() => {
      dispatch(matchesActions.getMatches(true));
      dispatch(matchesActions.getAffinyMatches());
    });
  };

  return {
    answers,
    searchCriteriaAnswers,
    updateQuestionAnswer,
    saveSearchCriteria,
  };
};
